export type ExpiryPresetKey = "30d" | "90d" | "1y" | "never";

export const EXPIRY_PRESETS: Array<{ key: ExpiryPresetKey; label: string }> = [
  { key: "30d", label: "30 days" },
  { key: "90d", label: "90 days" },
  { key: "1y", label: "1 year" },
  { key: "never", label: "Never" },
];

export function expiryFromPreset(key: ExpiryPresetKey, now: Date = new Date()): string | null {
  if (key === "never") return null;

  const d = new Date(now.getTime());

  if (key === "30d") {
    d.setUTCDate(d.getUTCDate() + 30);
  } else if (key === "90d") {
    d.setUTCDate(d.getUTCDate() + 90);
  } else if (key === "1y") {
    d.setUTCFullYear(d.getUTCFullYear() + 1);
  }

  return d.toISOString();
}

// Convention: "Never" and "Expired" are status-label tokens (always
// capitalised). Other return values are relative phrases ("in 3 days",
// "today") and stay lowercase to read naturally inline.
export function formatExpiresAt(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return "Never";

  const exp = Date.parse(iso);
  if (!Number.isFinite(exp)) return "Never";

  const diffMs = exp - now.getTime();
  const diffDays = Math.floor(diffMs / 86_400_000);

  if (diffDays < 0) return "Expired";
  if (diffDays === 0) return "today";
  if (diffDays === 1) return "in 1 day";
  return `in ${diffDays} days`;
}

export function isExpiringSoon(iso: string | null | undefined, now: Date = new Date()): boolean {
  if (!iso) return false;

  const exp = Date.parse(iso);
  if (!Number.isFinite(exp)) return false;

  const remaining = exp - now.getTime();
  return remaining > 0 && remaining < 7 * 86_400_000;
}
